<template>
  <div v-bind:class="{'notification-permission': true, show: this.$store.state.notificationPermission.show}">
    <span>Please enable notification for Backoffice.</span>
    <a class="button" href="javascript:;" @click="showNotificationPermission">ENABLE</a>
  </div>
</template>

<script>
export default {
  name: 'notification-permission',
  methods: {
    showNotificationPermission () {
      this.$plugins.fcm.start(this)
    }
  }
}
</script>

<style lang="scss" scoped>
.notification-permission {
  display: none;
  background-color: #F25E0D;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  padding: 15px;
  margin: 25px;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.5);
  transition: all 250ms;
  text-align: center;
  position: relative;

  &.show{ display: block; }
  span{
    display: block;
    margin-bottom: 7px;
  }
  & .button{
    margin-left: 10px;
    display: block;
  }

  &:before{
    content: '';
    display:block;
    position: absolute;
    border:2px solid #F25E0D;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
    border-radius: 3px;
    opacity: 0;
    animation: pulsate 1s linear infinite forwards;
  }
}

@keyframes pulsate{
  0%, 100%{
    transform: scale(.95);
    opacity: 0;
  }
  65%{
    transform: scale(1.05);
    opacity: 1
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App/NotificationPermission.vue